import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import URLs from "constants/urls";
import MonthlyOverView from "./monthlyOverView";
export default function MonthEnd() {
  return (
    <DashboardLayout>
      <MonthlyOverView url={URLs.monthEndUrl} />
    </DashboardLayout>
  );
}
